<template>
  <div class="page">
    <div class="page-content">
    <el-form
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="mcc描述" prop="mccName">
                <el-input
                    v-model="queryForm.mccName"
                    placeholder="mcc类型描述"
                    clearable
                    size="small"
                ></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 80px">
                <el-button size="small" type="primary" icon="el-icon-search" @click="searchBrandList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
      </div>
      <!-- 列表数据 -->
      <el-table
        height='100%'
        :data="shopBrandList"
        row-key="id"
        size="small"
        border
        v-loading="loading"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="mccName"
          label="mcc描述"
          min-width="10%"
        >
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="mccCode"
          label="mcc编码"
          min-width="10%"
        >
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="scope"
          label="操作"
          min-width="10%"
        >
          <template slot-scope="scope">
            <el-button type="primary" @click="selectChange(scope.row)">选择</el-button>
          </template>
       </el-table-column>
        
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
    </div>
</template>

<script>
import { Refresh} from '@v2icons/tabler';
import { get, post, deleteFun, upload ,postJson } from '@/utils/request.js';
export default {
   components: {
    Refresh
  },  
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopBrandList();
                this.getBrandList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopBrandList();
                this.getBrandList();
                this.$emit('resetCheckState');
            }
        }
    },
    props: { 
      mccCodeName: {
            type: String,
            default: ''
        },
        labelName: {
            type: String,
            default: ''
        },
        orgType: {
            type: Number ,
            default: null, 
        }
    },
    data() {
        return {
            queryForm: { 
                mccName:'',
                orgType: null,
            },
            timeRange: [],
            loading: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            shopBrandList: [],//列表数据
            groupValue: [],
            waitMoney:null
        };
    },
    mounted() {
        if (this.mccCodeName) {
            this.queryForm.mccName = this.mccCodeName;
        }
        if (this.orgType !== null) {
            this.queryForm.orgType = this.orgType;
        }
        this.getBrandList();
    },
    methods: {
       
     
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopBrandList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopBrandList = [];
        },
       resetDialog() {
            this.queryForm = {
                mccName: '',
                orgType: null,
            };
            if (this.orgType !== null) {
                this.queryForm.orgType = this.orgType;
            }
            this.resetShopBrandList();
            this.getBrandList();
        },
        refreshShopBrandList() {
            this.resetShopBrandList();
            this.getBrandList();
        },
        searchBrandList() {
            this.currentPage = 1;
            this.getBrandList();
        },
        // 列表数据请求
        getBrandList() {
                this.loading = true;
                get(`/newFastPay/mccQuery`, {
                    mccName: this.queryForm.mccName.trim(),
                    orgType: this.queryForm.orgType,
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                }).then((res) => {
                    this.loading = false;
                    if (res.code == 200) {
                        // 如果后端返回的数据结构中包含分页信息
                        if (res.data && res.data.data) {
                            this.shopBrandList = res.data.data.list || res.data.data;
                            this.totalNum = res.data.data.total || 0;
                        } else {
                            // 如果后端直接返回列表数据
                            this.shopBrandList = res.data || [];
                            // 由于没有total字段，我们只能根据当前页数据判断是否还有更多数据
                            this.totalNum = (this.currentPage - 1) * this.pageSize + this.shopBrandList.length;
                            
                            // 如果当前页数据少于pageSize，说明已经是最后一页
                            if (this.shopBrandList.length < this.pageSize) {
                                // 不增加totalNum
                            } else {
                                // 假设还有更多数据，增加pageSize来允许继续翻页
                                this.totalNum += 1;
                            }
                        }
                    }else{
                        this.$message.error(res.message);
                    }
                });  
             },
        resetQueryFrom() {
            this.getBrandList();
        },
        
        selectChange(value) {
           this.$emit('radioThis',value,false)
        },
        currentChange(page) {
            this.currentPage = page;
            this.getBrandList();
        },
        sizeChange(size) {
            this.pageSize = size;
            // 重置到第一页
            this.currentPage = 1;
            this.getBrandList();
        },
    }
};
</script>

<style lang="scss" scoped>



::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
.count{
    margin-right:1.5625vw;
}
::v-deep .el-table__empty-block{
   min-height:500px !important;
}
</style>
